/**
 * Deep links Mini App: https://t.me/<bot>/<app>?startapp=<param>
 * или https://t.me/<bot>?startapp=<param> (для Main Mini App).
 * Параметр start_param ограничен: A-Z a-z 0-9 _ - , до 512 символов.
 * Формат: "l_<id>" — объявление, "c_<id>" — переписка в чате (ссылка из уведомления).
 */

const LISTING_PREFIX = 'l_';
const CHAT_PREFIX = 'c_';
const START_PARAM_RE = /^[A-Za-z0-9_-]{1,512}$/;

export function listingStartParam(listingId: string | bigint | number): string {
  const id = String(listingId);
  if (!/^\d{1,19}$/.test(id)) throw new RangeError('Invalid listing id');
  return `${LISTING_PREFIX}${id}`;
}

export function chatStartParam(conversationId: string | bigint | number): string {
  const id = String(conversationId);
  if (!/^\d{1,19}$/.test(id)) throw new RangeError('Invalid conversation id');
  return `${CHAT_PREFIX}${id}`;
}

export type StartTarget = { type: 'listing'; listingId: string } | { type: 'chat'; conversationId: string } | { type: 'home' };

export function parseStartParam(param: string | null | undefined): StartTarget {
  if (!param || !START_PARAM_RE.test(param)) return { type: 'home' };
  if (param.startsWith(LISTING_PREFIX)) {
    const id = param.slice(LISTING_PREFIX.length);
    if (/^\d{1,19}$/.test(id)) return { type: 'listing', listingId: id };
  }
  if (param.startsWith(CHAT_PREFIX)) {
    const id = param.slice(CHAT_PREFIX.length);
    if (/^\d{1,19}$/.test(id)) return { type: 'chat', conversationId: id };
  }
  return { type: 'home' };
}

/**
 * Ссылка на объявление. Если задано короткое имя Mini App (BotFather /newapp) —
 * используется прямая ссылка, иначе ссылка на Main Mini App бота.
 */
export function listingShareUrl(botUsername: string, listingId: string | bigint, appShortName?: string | null): string {
  const param = listingStartParam(listingId);
  const bot = botUsername.replace(/^@/, '');
  return appShortName
    ? `https://t.me/${bot}/${appShortName}?startapp=${param}`
    : `https://t.me/${bot}?startapp=${param}`;
}
